export const intersection = (a, b) => {
  return a.filter((value) => !b.find((o) => o === value.serialNumber));
};

export const recLookup = (obj, path) => {
  if (!path) return undefined;

  // eslint-disable-next-line prefer-const
  let paths = String(path).split('.'),
    current = { ...obj },
    i;

  if (paths.length <= 1) {
    return current[paths[0]];
  }

  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]]) {
      current = current[paths[i]];
    } else {
      return undefined;
    }
  }
  return current;
};

export const intersectionMesh = (a, b) => {
  return a.filter((value) => b.find((o) => o.serialNumber === value.serialNumber));
};

export const statusText = (status) => {
  switch (status) {
    case 0:
      return <p className="text-red">{` ${capitalizeFirstLetter('offline')}`}</p>;
    case 1:
      return <p className="text-green">{` ${capitalizeFirstLetter('online')}`}</p>;

    default:
      return <p className="text-dark-blue">{` ${capitalizeFirstLetter('unassigned')}`}</p>;
  }
};

export const meshConfiguredStateRender = (status) => {
  switch (status) {
    case 1:
      return <p className="text-red">{` ${capitalizeFirstLetter('Not configured')}`}</p>;
    case 2:
      return <p className="text-green">{` ${capitalizeFirstLetter('Configured')}`}</p>;
    case 3:
      return <p className="text-dark-blue">{` ${capitalizeFirstLetter('Reset Pending')}`}</p>;
    case 4:
      return <p className="text-dark-blue">{` ${capitalizeFirstLetter('Configure Pending')}`}</p>;
    case 5:
      return <p className="text-dark-blue">{` ${capitalizeFirstLetter('Reconfigure Pending')}`}</p>;
    case 6:
      return <p className="text-red">{` ${capitalizeFirstLetter('Configure Failed')}`}</p>;
    case 7:
      return <p className="text-red">{` ${capitalizeFirstLetter('Reset Failed')}`}</p>;

    default:
      return <p className="text-dark-blue">{` ${capitalizeFirstLetter('Unindentified')}`}</p>;
  }
};

export const meshConfiguredStateOptions = [
  { id: 1, name: 'Not configured' },
  { id: 2, name: 'Configured' },
  { id: 3, name: 'Reset Pending' },
  { id: 4, name: 'Configure Pending' },
  { id: 5, name: 'Reconfigure Pending' },
  { id: 6, name: 'Configure Failed' },
  { id: 7, name: 'Reset Failed' }
]


const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};


/**
 * BIT MAPPING EXPLANATION & CHEAT SHEET
 * 
 * This logic uses bitmasking to determine supported access types.
 * NOTE: The `bits.slice` logic explicitly cuts out the 4th and 5th bits 
 * from the right. Because of this, decimal values 8 and 16 are skipped.
 * 
 * --- Value Mapping ---
 *    1 = hf_cards     (HF Cards)
 *    2 = lf125        (LF125)
 *    4 = mobile_ble   (Mobile BLE)- SO actually mobile_ble is 28
 *  ( 8 = Skipped/Ignored )- BELONGS to mobile_ble - SO actually mobile_ble is 28
 *  (16 = Skipped/Ignored )- BELONGS to mobile_ble - SO actually mobile_ble is 28
 *   32 = mobile_nfc   (Mobile NFC)-
 *   64 = qr_code      (QR Code)
 *  128 = wallet       (Wallet)
 *  256 = fingerprint  (Fingerprint)
 *  512 = keypad       (Keypad)
 * 1024 = ble          (BLE Remote)
 * 
 * --- How to calculate manually (Example: 39) ---
 * Break the number down by subtracting the largest values from the table above:
 *   39 fits 32 -> 39 - 32 = 7  (mobile_nfc)
 *    7 fits  4 ->  7 -  4 = 3  (mobile_ble)
 *    3 fits  2 ->  3 -  2 = 1  (lf125)
 *    1 fits  1 ->  1 -  1 = 0  (hf_cards)
 * Selected types for 39: mobile_nfc, mobile_ble, lf125, hf_cards
 */

export const allCredTypes = [
  { id: 'hf_cards', name: 'HF Cards' },
  { id: 'lf125', name: 'LF125' },
  { id: 'mobile_ble', name: 'Mobile BLE' },
  { id: 'mobile_nfc', name: 'Mobile NFC' },
  { id: 'qr_code', name: 'QR Code' },
  { id: 'wallet', name: 'Wallet' },
  { id: 'fingerprint', name: 'Fingerprint' },
  { id: 'keypad', name: 'Keypad' },
  { id: 'ble', name: 'BLE Remote' },
]

export const credsTypesMap = {
  hf_cards: false,
  lf125: false,
  mobile_ble: false,
  mobile_nfc: false,
  qr_code: false,
  wallet: false,
  fingerprint: false,
  keypad: false,
  ble: false,
}

export function getFileToDownload(response, filename) {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || response.headers['content-type']; //or any other extension
  link.click();
}
